import { render, staticRenderFns } from "./MfaVerify.vue?vue&type=template&id=070a2642&scoped=true"
import script from "./MfaVerify.vue?vue&type=script&lang=js"
export * from "./MfaVerify.vue?vue&type=script&lang=js"
import style0 from "./MfaVerify.vue?vue&type=style&index=0&id=070a2642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070a2642",
  null
  
)

export default component.exports